import React from 'react';

import RecorderField from 'components/Recorder/Recorder.form';

import { IChunkModel } from '@common/models/Chunks/Chunk';

type PropsType = {
	chunkModel: IChunkModel;
	hideDeleteButton?: boolean;
};

function ChunkDictaphone({ chunkModel, hideDeleteButton }: PropsType) {
	return (
		<RecorderField hideDeleteButton={hideDeleteButton} name={`${chunkModel.id}.dictaphone_url.0`} />
	);
}

export default ChunkDictaphone;
